import {Col, Row} from "react-bootstrap";
import * as React from "react";
import {LocalShipping, Upload} from "@mui/icons-material";


export function DeliveryAlert ({ shipping, deliveryMethod, values }) {

  let message;
  let c = "alert alert-warning mb-4";

  switch (deliveryMethod) {
    case '1':
      message = <span>You have chosen to <strong>pick-up</strong> your order from iStore.</span>;
      c = "alert alert-primary mb-4"; break;

    case '2':
      message = <span>Your order will be <strong>delivered</strong> to the address:</span>;
      break;

    case '3':
      message = <span>
        Your order will be <strong>delivered</strong> to the address:<br/>
        {values.delivery_number_street} {values.delivery_suburb} {values.delivery_state} {values.delivery_postcode}
      </span>;
      break;
    default:
      message = <span>An error occurred. Please refresh the page and try again.</span>;
  }

  if (shipping !== undefined) {
    let shipping_element = window.document.querySelector('[name="shipping"]:checked');
    let label = shipping_element && shipping_element?.labels[0].textContent;

    if (label && message) {
      return (
        <div className={c}>
          <Row>
            <Col xs={12} sm={2} className="text-center">
              { deliveryMethod === 'pickup' ? <Upload style={{fontSize: '56px'}}/> : <LocalShipping style={{fontSize: '56px'}} /> }
            </Col>
            <Col xs={12} sm={10}>{message}<br/>{deliveryMethod !== 'deliver_new' && label}</Col>
          </Row>
        </div>
      );
    }
  }

  return null;

}